import { useEffect } from 'react';

interface SchemaOrgProps {
  schema: object | object[];
}

export default function SchemaOrg({ schema }: SchemaOrgProps) {
  useEffect(() => {
    const schemaArray = Array.isArray(schema) ? schema : [schema];
    const scriptId = `schema-${JSON.stringify(schema).substring(0, 20)}`;
    
    // 移除旧的 schema script
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    // 添加新的 schema script
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaArray.length === 1 ? schemaArray[0] : schemaArray);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(scriptId);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [schema]);

  return null;
}